import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useGetInfoProductDetail = () => {
  const [getInfoLoading, setGetInfoLoading] = useState(true);
  const [gottenProduct, setGottenProduct] = useState({});

  const { enqueueSnackbar } = useSnackbar();

  const getEditInfo = guid => {
    setGetInfoLoading(true);

    axiosClient
      .get(`Product/Branch/Packaging/Update?GUID=${guid}`)
      .then(res => {
        if (res.status === 200) {
          setGottenProduct(res.data?.value);
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => enqueueSnackbar(err?.message, { variant: 'error' }))
      .finally(() => setGetInfoLoading(false));
  };

  return [getEditInfo, getInfoLoading, gottenProduct];
};

export default useGetInfoProductDetail;
